var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCgpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedCgpt0)",
    d: "m5.571 16.526l1.286-.883V8.357l1.5-1.5h7.457l1.329 1.5l.805-.484a.242.242 0 0 0 .043-.373L16.2 5.64a.23.23 0 0 0-.163-.068H7.731a.23.23 0 0 0-.163.068L5.64 7.646a.24.24 0 0 0-.069.167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E7CD",
    d: "m8.357 6.857l-1.5 1.5v7.316l1.5 1.47h7.286l1.5-1.5V8.327l-1.286-1.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedCgpt1)",
    d: "M18.197 11.76h-1.054v3.814l-1.5 1.569H8.357l-1.5-1.5l-1.286.883l1.77 1.834a.23.23 0 0 0 .163.069h8.533c.06 0 .12-.026.163-.069l2.16-2.241a.25.25 0 0 0 .068-.172V12a.24.24 0 0 0-.231-.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A24",
    d: "M10.286 13.714a.857.857 0 1 0 0-1.714a.857.857 0 0 0 0 1.714m3.428 0a.857.857 0 1 0 0-1.714a.857.857 0 0 0 0 1.714"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedCgpt0",
    x1: 17.864,
    x2: 4.945,
    y1: 6.97,
    y2: 15.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#684BFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#4663E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#4380E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#17DAC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18D6C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedCgpt1",
    x1: 17.97,
    x2: 5.198,
    y1: 6.034,
    y2: 9.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F19C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E9BE4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C653"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgpt);
export default __webpack_public_path__ + "static/media/cgpt.1f5e79245153db6721ebc796e642238f.svg";
export { ForwardRef as ReactComponent };